import { ShieldLockRegular } from '@fluentui/react-icons'
import { Tooltip } from '@fluentui/react-components'
import styles from './InvestigationModeBadge.module.css'

interface InvestigationModeBadgeProps {
  compact?: boolean
}

export function InvestigationModeBadge({ compact = false }: InvestigationModeBadgeProps) {
  const content = (
    <div className={styles.root}>
      <ShieldLockRegular className={styles.icon} aria-hidden="true" />
      {!compact && (
        <div className={styles.copy}>
          <span className={styles.eyebrow}>Mode</span>
          <span className={styles.label}>Read-only investigation</span>
        </div>
      )}
    </div>
  )

  return (
    <Tooltip
      content="SOC-Copilot analyzes and recommends. Response actions remain under human control."
      relationship="label"
      withArrow
    >
      {content}
    </Tooltip>
  )
}
